import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getGoalBoxId,
  getOtherSideBoxId,
  TURN_BOX_IDS,
} from "../constants/box_id";
import { BoxId } from "../types/box_id";
import { initialState } from "./state";

export const slice = createSlice({
  name: "app",
  initialState,
  reducers: {
    handlePressBox: (state, { payload }: PayloadAction<{ boxId: BoxId }>) => {
      const count = state.boxBallCount[payload.boxId];
      state.handBallCount = count;
      state.boxBallCount[payload.boxId] = 0;
    },
    releaseBallToBox: (
      state,
      { payload }: PayloadAction<{ boxId: BoxId; isLast?: boolean }>
    ) => {
      const beforeBallCount = state.boxBallCount[payload.boxId];
      state.handPositionBoxId = payload.boxId;
      state.boxBallCount[payload.boxId] += 1;
      state.handBallCount -= 1;
      // 横取り判定
      const isMyTurnBox = TURN_BOX_IDS[state.turn].includes(payload.boxId);
      const otherSideBoxId = getOtherSideBoxId(payload.boxId);
      const otherSideBoxCount = state.boxBallCount[otherSideBoxId];
      if (
        payload.isLast &&
        isMyTurnBox &&
        beforeBallCount === 0 &&
        otherSideBoxCount > 0
      ) {
        state.stealPositionBoxId = otherSideBoxId;
        state.boxBallCount[payload.boxId] -= 1;
        state.boxBallCount[otherSideBoxId] = 0;
        state.boxBallCount[getGoalBoxId(state.turn)] += otherSideBoxCount + 1;
      }
    },
    toggleTurn: (state) => {
      const currentTurn = state.turn;
      state.turn = currentTurn === "A" ? "B" : "A";
    },
    hideHand: (state) => {
      state.handPositionBoxId = null;
    },
    hideSteal: (state) => {
      state.stealPositionBoxId = null;
    },
    resetGame: () => {
      return initialState;
    },
  },
});
